import GrayBackground from "./GrayBackground";

export default GrayBackground;
